// Returns the value of the query string variable with the given key,
// or an empty string if it doesn't exist
//
// copied from https://gist.github.com/1771618
export const getUrlVar = (key, queryString?: string) => {
  queryString = queryString || window.location.search;
  const result = new RegExp(key + "=([^&]*)", "i").exec(queryString);
  return (result && decodeURIComponent(result[1])) || "";
};
